import CustomAccordion from "@/utils/CustomAccordion";
import CmsPageTitle from "@/utils/CmsPageTitle";
import { useEffect, useState } from "react";
import {
  Box
} from "@chakra-ui/react";
import ContainerBox from "@/utils/ContainerBox";
import { useDispatch, useSelector } from "react-redux";
import { manageCMS } from "store/authSlice";
const Faq = () => {
  const dispatch=useDispatch();
  const {faqs,faqs_mentor,faqs_mentee}=useSelector(state=>state.auth);
   const [activeFaqs, setactiveFaqs] = useState([]);
   const [activefaqs_mentor, setactivefaqs_mentor] = useState([]);
   const [activefaqs_mentee, setactivefaqs_mentee] = useState([]);
   useEffect(()=>{
      dispatch(manageCMS({method:'get',type:'faqs'}));
      dispatch(manageCMS({method:'get',type:'faqs_mentee'}));
      dispatch(manageCMS({method:'get',type:'faqs_mentor'}));
    },[]);
    console.log(faqs_mentor,"faqs",faqs_mentee);
    
    useEffect(()=>{
      setactiveFaqs(faqs?.filter((d)=>d?.status === true))
      setactivefaqs_mentor(faqs_mentor?.filter((d)=>d?.status === true))
      setactivefaqs_mentee(faqs_mentee?.filter((d)=>d?.status === true))
    }, [faqs, faqs_mentee, faqs_mentor]);
  return (
    <Box>
      <CmsPageTitle title="Frequently Asked Question"/>
      <ContainerBox Style="gap-4 sm:gap-8">
        <Box className="container mx-auto mt-5">
          
          <h3 className="heading-color">General</h3>
          <CustomAccordion items={activeFaqs || []} />
        </Box>
        <Box className="container mx-auto">
          <h3 className="heading-color">Mentor</h3>
          <CustomAccordion items={activefaqs_mentor || []} />
        </Box>
        <Box className="container mx-auto">
          <h3 className="heading-color">Mentee</h3>
          <CustomAccordion items={activefaqs_mentee || []} />
        </Box>
      </ContainerBox>
    </Box>
  );
};

export default Faq;
